import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { sun } from "../../data/sun";
import { useSettingsStore } from "../../store/settingsStore";
import { toSceneRadius } from "../../utils/scaling";
import { getLiveSimulationDate } from "../../store/liveClock";
import { dateToJulianDate } from "../../astronomy/julianDate";
import { calculateBodyRotation } from "../../astronomy/rotation";
import { useSceneStore } from "../../store/sceneStore";
import { BodyLabel } from "./BodyLabel";

export function Sun() {
  const meshRef = useRef<THREE.Mesh>(null);
  const scale = useSettingsStore((s) => s.scale);
  const showLabels = useSceneStore((s) => s.showLabels);
  const selectedBodyId = useSceneStore((s) => s.selectedBodyId);
  const focusBody = useSceneStore((s) => s.focusBody);
  const radius = toSceneRadius(sun.physical.meanRadiusKm, scale);
  const selected = selectedBodyId === "sun";

  useFrame(() => {
    const jd = dateToJulianDate(getLiveSimulationDate());
    const rot = calculateBodyRotation(sun.rotation, jd);
    if (meshRef.current) {
      meshRef.current.rotation.y = rot;
    }
  });

  return (
    <group>
      <mesh
        ref={meshRef}
        onClick={(e) => {
          e.stopPropagation();
          focusBody("sun");
        }}
        scale={selected ? 1.03 : 1}
      >
        <sphereGeometry args={[radius, 64, 64]} />
        <meshBasicMaterial color={sun.color ?? "#FDB813"} />
      </mesh>
      <pointLight
        intensity={2.2}
        distance={6000}
        decay={0.2}
        color="#fff5d6"
      />
      <mesh>
        <sphereGeometry args={[radius * 1.08, 32, 32]} />
        <meshBasicMaterial
          color="#ffcc66"
          transparent
          opacity={0.18}
          depthWrite={false}
        />
      </mesh>
      {showLabels && <BodyLabel name={sun.name} sphereRadius={radius} />}
    </group>
  );
}
